// extracted by mini-css-extract-plugin
export default {"container":"ApplyCompletePage_container__g3qkM","usertype":"ApplyCompletePage_usertype__RH3mY","confirmBtn":"ApplyCompletePage_confirmBtn__ENrvj"};